import { render, staticRenderFns } from "./Claim-Overview.vue?vue&type=template&id=a043c3bc"
import script from "./Claim-Overview.vue?vue&type=script&lang=js"
export * from "./Claim-Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports